module.exports = __webpack_public_path__ + "img/pin_substitution_red.b9bb515a.svg";